import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { id: "Bodies" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Overview = _resolveComponent("Overview")!
  const _component_Editor = _resolveComponent("Editor")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.page === 'BodyOverview')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_Overview)
        ]))
      : _createCommentVNode("v-if", true),
    (_ctx.page === 'BodyEditor')
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_Editor)
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}